import useFormActionWithCaptcha from "../captcha/useFormActionWithCaptcha";
import useGoogleRecaptcha from "./useGoogleRecaptcha";

function useFormActionWithGoogleCaptcha(formAction, captchaConfig) {
	return useFormActionWithCaptcha(formAction, { ...captchaConfig, useHook: useGoogleRecaptcha });
}

export default useFormActionWithGoogleCaptcha;
